export const STORY_BEATS = {
  GAME_START: {
    id: 'GAME_START',
    lines: [
      {
        text: "Welcome to Money City! I've spotted a major market opportunity for us to build wealth.",
        speaker: {
          id: 'scout',
          name: 'Market Analyst Alex'
        }
      },
      {
        text: "The key to success is merging our assets. Start with small investments, then combine them to create greater value.",
        speaker: {
          id: 'chef',
          name: 'Financial Advisor Morgan'
        }
      },
      {
        text: "Indeed, the financial landscape rewards those who understand how to grow their investments through strategic merging.",
        speaker: {
          id: 'elder',
          name: 'CEO Goldstein'
        }
      },
      {
        text: "We'll start with basic pennies, then merge them into nickels, dimes, and beyond. Our fortune depends on it!",
        speaker: {
          id: 'elder',
          name: 'CEO Goldstein'
        }
      },
      {
        text: "I'll organize our investment strategy. Let's start with the basics of merging assets before we move to more complex operations.",
        speaker: {
          id: 'architect',
          name: 'Investment Director Taylor'
        }
      }
    ],
    duration: 5000
  },

  TOWNHALL_COMPLETE: {
    id: 'TOWNHALL_COMPLETE',
    lines: [
      {
        text: "The Central Bank is operational. This will be our financial headquarters for all our merging operations.",
        speaker: {
          id: 'elder',
          name: 'CEO Goldstein'
        }
      },
      {
        text: "Now we can track our merged assets and plan our next investments more effectively.",
        speaker: {
          id: 'chef',
          name: 'Financial Advisor Morgan'
        }
      },
      {
        text: "Remember, the key to wealth is not just generating assets, but strategically merging them to create higher value.",
        speaker: {
          id: 'scout',
          name: 'Market Analyst Alex'
        }
      }
    ],
    duration: 5000,
    trigger: {
      type: 'BUILDING_COMPLETE',
      buildingId: 'townhall'
    }
  },

  HOUSE_COMPLETE: {
    id: 'HOUSE_COMPLETE',
    lines: [
      {
        text: "The Financial Office is ready! Our team can now analyze which mergers will yield the best returns.",
        speaker: {
          id: 'builder',
          name: 'Office Manager William'
        }
      },
      {
        text: "With this office, we can better handle frozen assets that can't be moved but can still be merged with.",
        speaker: {
          id: 'chef',
          name: 'Financial Advisor Morgan'
        }
      },
      {
        text: "Some assets may be locked in place, but that doesn't mean they can't be part of our merging strategy.",
        speaker: {
          id: 'scout',
          name: 'Market Analyst Alex'
        }
      }
    ],
    duration: 5000,
    trigger: {
      type: 'BUILDING_COMPLETE',
      buildingId: 'house'
    }
  },

  SHOP_COMPLETE: {
    id: 'SHOP_COMPLETE',
    lines: [
      {
        text: "The Stock Exchange is operational! We can now generate more basic assets to fuel our merging strategy.",
        speaker: {
          id: 'merchant',
          name: 'Broker Sam'
        }
      },
      {
        text: "Our generators will provide a steady stream of pennies that we can merge into higher-value assets.",
        speaker: {
          id: 'merchant',
          name: 'Broker Sam'
        }
      },
      {
        text: "Remember, efficient merging is the key to maximizing our returns. Don't let the board get too cluttered!",
        speaker: {
          id: 'chef',
          name: 'Financial Advisor Morgan'
        }
      }
    ],
    duration: 5000,
    trigger: {
      type: 'BUILDING_COMPLETE',
      buildingId: 'shop'
    }
  },

  WORKSHOP_COMPLETE: {
    id: 'WORKSHOP_COMPLETE',
    lines: [
      {
        text: "The Mint is operational! We can now create more diverse currency for our merging operations.",
        speaker: {
          id: 'craftsman',
          name: 'Treasury Director Tom'
        }
      },
      {
        text: "With the mint, we'll occasionally generate nickels directly, saving us some merging steps.",
        speaker: {
          id: 'chef',
          name: 'Financial Advisor Morgan'
        }
      },
      {
        text: "Strategic use of our generators combined with smart merging will accelerate our wealth accumulation.",
        speaker: {
          id: 'elder',
          name: 'CEO Goldstein'
        }
      }
    ],
    duration: 5000,
    trigger: {
      type: 'BUILDING_COMPLETE',
      buildingId: 'workshop'
    }
  },

  WAREHOUSE_COMPLETE: {
    id: 'WAREHOUSE_COMPLETE',
    lines: [
      {
        text: "The Treasury is secure. Now we can safely store our higher-value merged assets.",
        speaker: {
          id: 'merchant',
          name: 'Broker Sam'
        }
      },
      {
        text: "As you've learned, merging is the path to wealth. Two pennies become a nickel, two nickels become a dime, and so on.",
        speaker: {
          id: 'elder',
          name: 'CEO Goldstein'
        }
      },
      {
        text: "And don't forget about frozen assets - they can't be moved, but they can still be merged with matching assets.",
        speaker: {
          id: 'scout',
          name: 'Market Analyst Alex'
        }
      }
    ],
    duration: 5000,
    trigger: {
      type: 'BUILDING_COMPLETE',
      buildingId: 'warehouse'
    }
  },

  MARKET_COMPLETE: {
    id: 'MARKET_COMPLETE',
    lines: [
      {
        text: "The Trading Floor is open for business! Now we can execute our merging strategies more efficiently.",
        speaker: {
          id: 'merchant',
          name: 'Broker Sam'
        }
      },
      {
        text: "With this trading floor, we can handle more complex merging scenarios involving multiple generators and frozen assets.",
        speaker: {
          id: 'elder',
          name: 'CEO Goldstein'
        }
      },
      {
        text: "Remember, the goal is to create the highest value assets through strategic merging. Plan your moves carefully!",
        speaker: {
          id: 'chef',
          name: 'Financial Advisor Morgan'
        }
      }
    ],
    duration: 5000,
    trigger: {
      type: 'BUILDING_COMPLETE',
      buildingId: 'market'
    }
  },

  TEMPLE_COMPLETE: {
    id: 'TEMPLE_COMPLETE',
    lines: [
      {
        text: "The Investment Bank is ready. We've now mastered the art of merging assets to build wealth.",
        speaker: {
          id: 'elder',
          name: 'CEO Goldstein'
        }
      },
      {
        text: "From simple penny mergers to creating safes full of wealth, you've learned all the key principles of financial growth.",
        speaker: {
          id: 'craftsman',
          name: 'Treasury Director Tom'
        }
      },
      {
        text: "Our merging strategy has proven successful. We've built a financial empire through smart combinations.",
        speaker: {
          id: 'elder',
          name: 'CEO Goldstein'
        }
      },
      {
        text: "But there's always more wealth to be created. Keep merging, keep growing, and watch your fortune multiply!",
        speaker: {
          id: 'scout',
          name: 'Market Analyst Alex'
        }
      }
    ],
    duration: 5000,
    trigger: {
      type: 'BUILDING_COMPLETE',
      buildingId: 'temple'
    }
  }
};
